/* eslint-disable @typescript-eslint/naming-convention */
// TODO: https://griosf.atlassian.net/browse/RVLS-7906
const addOnTypeTitle: { [key: string]: string } = {
  "AD_LITE AD_LITE": "Enjoy with fewer interruptions",
  "SPY SPY": "Spy on your rival"
};

// TODO: https://griosf.atlassian.net/browse/RVLS-7906
const addOnTypeDescription: { [key: string]: string } = {
  "AD_LITE AD_LITE": "Read premium articles & forums with no ads.",
  "SPY SPY": "Read only access to see what your Rival is up to."
};
/* eslint-enable @typescript-eslint/naming-convention */

// TODO: https://griosf.atlassian.net/browse/RVLS-7906
export default {
  addOnDescription: addOnTypeDescription,
  addOnTitle: addOnTypeTitle,
  annualUpgradeText:
    "Become a gold member & save 16% over monthly billing by paying for an entire year upfront.",
  annualUpgradeTitle: "Upgrade to annual"
};
